import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "agent-desktop-shell"
}
const _hoisted_2 = { class: "agent-desktop-header" }
const _hoisted_3 = { class: "agent-desktop-header-main" }
const _hoisted_4 = { class: "agent-title-wrap" }
const _hoisted_5 = { class: "agent-title-row" }
const _hoisted_6 = { class: "agent-title" }
const _hoisted_7 = { class: "agent-description" }
const _hoisted_8 = { class: "agent-chip-row" }
const _hoisted_9 = { class: "agent-footer" }
const _hoisted_10 = { class: "agent-actions" }
const _hoisted_11 = { class: "compact-title" }
const _hoisted_12 = { class: "d-flex align-center" }
const _hoisted_13 = { class: "compact-chip-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_AgentShareDialog = _resolveComponent("AgentShareDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(_ctx.variant === 'desktop' ? 'agent-desktop-card' : 'agent-compact-card'),
    color: "background",
    variant: "elevated",
    elevation: "4",
    onClick: _ctx.emitEdit
  }, {
    default: _withCtx(() => [
      (_ctx.variant === 'desktop')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_avatar, {
                  size: "48",
                  rounded: "lg",
                  class: "agent-avatar agent-icon-tile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: _ctx.iconName,
                      size: "small"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.agent.config.name), 1),
                    (_ctx.agent.config.publishedInfo?.isPublished)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          size: "small",
                          color: "success",
                          variant: "tonal",
                          class: "agent-live-chip"
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode(" LIVE ")
                          ])),
                          _: 1,
                          __: [4]
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.agent.config.description), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_chip, {
                size: "small",
                variant: "tonal",
                class: "agent-chip"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-earth",
                    size: "x-small",
                    start: ""
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.modelChipLabel), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                size: "small",
                variant: "outlined",
                class: "agent-chip"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-tools",
                    size: "x-small",
                    start: ""
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.toolsChipLabel), 1)
                ]),
                _: 1
              }),
              (_ctx.agent.config.embeddingOptions?.collections?.length)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    size: "small",
                    variant: "outlined",
                    class: "agent-chip"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-book-open-outline",
                        size: "x-small",
                        start: ""
                      }),
                      _cache[5] || (_cache[5] = _createTextVNode(" RAG "))
                    ]),
                    _: 1,
                    __: [5]
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "agent-footer-spacer" }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.canShare)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      text: "Share Agent",
                      location: "top"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          color: "primary",
                          icon: "mdi-share-variant",
                          size: "small",
                          variant: "plain",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showShare = true), ["stop"]))
                        }), null, 16)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.agent.config.publishedInfo?.publicUrl)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 1,
                      text: "Open in new window",
                      location: "top"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          color: "primary",
                          icon: "mdi-open-in-new",
                          size: "small",
                          variant: "plain",
                          href: _ctx.agent.config.publishedInfo.publicUrl,
                          target: "_blank",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }), null, 16, ["href"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.publishedSlug)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 2,
                      text: "Chat with Agent",
                      location: "top"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          color: "primary",
                          icon: "mdi-chat-outline",
                          size: "small",
                          variant: "plain",
                          onClick: _withModifiers(_ctx.goToChat, ["stop"])
                        }), null, 16, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_tooltip, {
                  text: "Edit Agent",
                  location: "top"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      color: "primary",
                      icon: "mdi-pencil-outline",
                      size: "small",
                      variant: "plain",
                      onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                    }), null, 16, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_card_item, { class: "py-3" }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "40",
                  rounded: "lg",
                  class: "mr-3 agent-icon-tile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      icon: _ctx.iconName,
                      size: "small"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.agent.config.publishedInfo?.publicUrl)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        text: "Open in new window",
                        location: "top"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            color: "primary",
                            icon: "mdi-open-in-new",
                            size: "small",
                            variant: "plain",
                            class: "mr-1",
                            href: _ctx.agent.config.publishedInfo.publicUrl,
                            target: "_blank",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }), null, 16, ["href"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.publishedSlug)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 1,
                        text: "Chat with Agent",
                        location: "top"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            color: "primary",
                            icon: "mdi-chat-outline",
                            size: "small",
                            variant: "plain",
                            class: "mr-1",
                            onClick: _withModifiers(_ctx.goToChat, ["stop"])
                          }), null, 16, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, {
                    text: "Edit Agent",
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        color: "primary",
                        icon: "mdi-pencil-outline",
                        size: "small",
                        variant: "plain",
                        onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                      }), null, 16, ["onClick"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center compact-title-row" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.agent.config.name), 1),
                    (_ctx.agent.config.publishedInfo?.isPublished)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "success",
                          size: "x-small",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("LIVE")
                          ])),
                          _: 1,
                          __: [7]
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_subtitle, { class: "compact-subtitle" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agent.config.description), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "pt-0 pb-3" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_v_chip, {
                    size: "small",
                    variant: "tonal",
                    class: "agent-chip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.modelChipLabel), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_chip, {
                    size: "small",
                    variant: "outlined",
                    class: "agent-chip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.toolsChipLabel), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.agent.config.embeddingOptions?.collections?.length)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        size: "small",
                        variant: "outlined",
                        class: "agent-chip"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("RAG")
                        ])),
                        _: 1,
                        __: [8]
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ], 64)),
      _createVNode(_component_AgentShareDialog, {
        modelValue: _ctx.showShare,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showShare) = $event)),
        ownerUsername: _ctx.username,
        slug: _ctx.publishedSlug,
        agentName: _ctx.agent.config.name
      }, null, 8, ["modelValue", "ownerUsername", "slug", "agentName"])
    ]),
    _: 1
  }, 8, ["class", "onClick"]))
}